(() => {
  const galleries = document.querySelectorAll('[id^="SpacetimePurchase-"]');

  galleries.forEach((root) => {
    if (root.dataset.galleryReady === 'true') return;
    root.dataset.galleryReady = 'true';

    const gallery = root.querySelector('.sp-gallery');
    const image = root.querySelector('[data-gallery-image]');
    const label = root.querySelector('[data-gallery-label]');
    const count = root.querySelector('[data-gallery-count]');
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const variantOptions = Array.from(root.querySelectorAll('.variant_option'));
    const previous = root.querySelector('.sp-gallery-arrow-left');
    const next = root.querySelector('.sp-gallery-arrow-right');

    if (!gallery || !image || thumbs.length === 0) return;

    const items = thumbs.map((thumb) => {
      const thumbImage = thumb.querySelector('img');
      return {
        color: thumb.dataset.galleryThumb,
        src: thumbImage ? thumbImage.src : '',
        alt: `${thumb.dataset.galleryThumb.charAt(0).toUpperCase()}${thumb.dataset.galleryThumb.slice(1)} Spacetime 65 wireless mechanical keyboard viewed from above`,
        thumb
      };
    });

    let currentIndex = Math.max(0, items.findIndex((item) => item.color === root.dataset.initialColor));

    const syncVariantState = () => {
      variantOptions.forEach((variantOption) => {
        const input = variantOption.querySelector('.productOption');
        variantOption.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    };

    const show = (index) => {
      currentIndex = (index + items.length) % items.length;
      const item = items[currentIndex];

      image.src = item.src;
      image.alt = item.alt;
      gallery.classList.remove('sp-gallery-pink', 'sp-gallery-white', 'sp-gallery-silver');
      gallery.classList.add(`sp-gallery-${item.color}`);

      if (label) label.textContent = item.color.charAt(0).toUpperCase() + item.color.slice(1);
      if (count) count.textContent = `${String(currentIndex + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;

      items.forEach((entry, entryIndex) => {
        const selected = entryIndex === currentIndex;
        entry.thumb.classList.toggle('is-active', selected);
        entry.thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    if (previous) previous.addEventListener('click', () => show(currentIndex - 1));
    if (next) next.addEventListener('click', () => show(currentIndex + 1));

    root.addEventListener('change', (event) => {
      const option = event.target.closest('.productOption');
      if (!option) return;

      syncVariantState();

      const value = String(option.value || option.title || '').toLowerCase();
      const matchIndex = items.findIndex((item) => {
        if (item.color === 'silver') return value.includes('silver') || value.includes('grey') || value.includes('gray');
        return value.includes(item.color);
      });

      if (matchIndex >= 0) show(matchIndex);
    });

    syncVariantState();
    show(currentIndex);
  });
})();
